function resizeNav() {
    var newHeight = window.innerHeight;
    $('.header-mobile-content').css('max-height', newHeight);
}

$(document).ready(function () {
    
    document.querySelectorAll('.add--border').forEach((el) => {
        const borderDiv = document.createElement('div');
        borderDiv.classList.add('border--nav');
        el.parentNode.insertBefore(borderDiv, el);
    });

      

    resizeNav();

    $(window).on('resize', function () {
        resizeNav();
    });


    //home change header color on scroll
    $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        if (scroll >= 100) {
            $('.home .site-header').addClass('active');
            $('.cover--down--link').addClass('not-active');
        } else {
            $('.home .site-header').removeClass('active');
            $('.cover--down--link').removeClass('not-active');
        }
    });

    // scroll top function
    $('.scroll--top').click(function () {
        $(window).scrollTop(0);
    });

    // copy current url to clipboard (blog single)
    function copyLink() {
        var copyText = window.location.href;
        console.log(copyText);
        navigator.clipboard.writeText(copyText);
    }
    $('.copy-link').click(function (e) {
        e.preventDefault();
        // console.log('test');
        copyLink();
        return false;
    });

    //dropdown function
    $('.menu-top > .menu-item-has-children').each(function () {
        $(this).children('a').addClass('dropdown-link');
    });
    $('.dropdown-link').each(function () {
        $(this).click(function (e) {
            e.preventDefault();

            $('.dropdown-link')
                .next()
                .not($(this).next())
                .removeClass('dropdown');
            $('.dropdown-link').next().not($(this).next()).slideUp();
            if ($(this).next().hasClass('dropdown')) {
                $(this).next().removeClass('dropdown');
            } else {
                $(this).next().addClass('dropdown');
            }
        });
    });
    $('.sub--dropdown').click(function (e) {
        e.preventDefault();
        if ($(this).next().hasClass('dropdown')) {
            $(this).next().removeClass('dropdown');
        } else {
            $(this).next().addClass('dropdown');
        }
    });
    $('.subheader--burger').click(function (e) {
        e.preventDefault();
        if ($('.sub--header--menu').hasClass('dropdown')) {
            $('.sub--header--menu').removeClass('dropdown');
            $('html, body').css({
                overflow: 'visible',
            });
        } else {
            $('.sub--header--menu').addClass('dropdown');
            $('html, body').css({
                overflow: 'hidden',
            });
        }
    });

    // Anker-Navigation (Mobile): nach Klick auf einen Anker-Link das Menü schliessen und Scrollen wieder erlauben
    $('.sub--header--menu .anchor--link').click(function () {
        $('.sub--header--menu').removeClass('dropdown');
        $('html, body').css({
            overflow: 'visible',
        });
    });

    // get active element for produkte pages
    $('.sub--header--menu .sub--link').each(function () {
        var parts = $(this).prop('href').split('/');
        var lastSegment = parts.pop() || parts.pop(); // handle potential trailing slash
        var partslink = window.location.href.split('/');
        var lastSegmentlink = partslink.pop() || partslink.pop(); // handle potential trailing slash
        if (lastSegmentlink == lastSegment) {
            $(this).addClass('active');
        }
    });

    // //close dropdown if click on page
    $(document).mouseup(function (e) {
        var container = $('.sub-menu, .dropdown-link');
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('.dropdown-link').next().removeClass('dropdown');
            $('.dropdown-link').next().slideUp();
        }
    });
    $(document).mouseup(function (e) {
        var container = $(
            '.sortiment--submenu, .sortiment--link, .sub--dropdown'
        );
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('.sortiment--submenu').removeClass('dropdown');
        }
    });
    $(document).mouseup(function (e) {
        var container = $('.sub--header--menu, .sub--link, .subheader--burger');
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('.sub--header--menu').removeClass('dropdown');
            // $('html, body').css({
            //     overflow: 'visible',
            // });
        }
    });

    $('.mobile--inner--wrapper .menu-item-has-children').each(function () {
        $(this).addClass('acc-submenu');
    });
    $('.acc-submenu:first-child > a').addClass('rotate');
    $('.acc-submenu:first-child > ul').slideDown('slow');
    $('.acc-submenu:first-child > ul').addClass('acc--menu--open');

    $('.mobile--inner--wrapper .menu-item-has-children').each(function () {
        $(this)
            .children('a')
            .click(function (e) {
                e.preventDefault();
                var thismenumain = $(this);
                var thismenu = $(this).next();

                if (thismenu.hasClass('acc--menu--open')) {
                    $(thismenu).removeClass('acc--menu--open');
                    $(thismenu).slideUp('slow');
                    $(thismenumain).removeClass('rotate');
                } else {
                    $('.menu-item-has-children ul').removeClass('acc--menu--open');
                    $('.menu-item-has-children ul').slideUp('slow');
                    $('.menu-item-has-children').children('a').removeClass('rotate');

                    $(thismenu).addClass('acc--menu--open');
                    $(thismenu).slideDown('slow');
                    $(thismenumain).addClass('rotate');
                }

            });
    });

    $('.burger--menu--toggle').click(function () {
        $('.burger--menu--toggle').prop('disabled', true);

        //mobile menu animation
        if (!$('.header-mobile-content').hasClass('header--open')) {
            //burger toggle animation
            $('.burger--menu--toggle').addClass('burger--closed');
            $('body').addClass('nav--open');

            //open menu
            $('.header-mobile-content')
                .addClass('header--open')
                .removeClass('header--closed');
            $('html, body').css({
                overflow: 'hidden',
            });
        } else {
            //burger toggle animation
            $('.burger--menu--toggle').removeClass('burger--closed');
            $('body').removeClass('nav--open');

            //close menu
            $('.header-mobile-content')
                .removeClass('header--open')
                .addClass('header--closed');
            $('html, body').css({
                overflow: 'visible',
            });

            // close submenus
            // $('#menu-main .dropdown-menu').removeClass('menu--slide--in');
            // $('#menu-main .dropdown-menu').slideUp('slow');
        }

        setTimeout(function () {
            // enable click after 1 second
            $('.burger--menu--toggle').prop('disabled', false);
        }, 500); // .5 second delay
    });

    // //close menu if click on page
    $(document).mouseup(function (e) {
        var container = $('.header--open, .header--burger, .sub--link');

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('.header-mobile-content').removeClass('header--open');
            $('.burger--menu--toggle').removeClass('burger--closed');
            $('html, body').css({
                overflow: 'visible',
            });
            $('body').removeClass('nav--open');

            // close submenus
            // $('#menu-main .dropdown-menu').removeClass('menu--slide--in');
            // $('#menu-main .dropdown-menu').slideUp('slow');
        }
    });

    //hide navbar on scroll
    $(function () {
        var lastScrollTop = 0,
            delta = 5;
        $(window).scroll(function () {
            var nowScrollTop = $(this).scrollTop();
            var scroll = $(window).scrollTop();

            if (Math.abs(lastScrollTop - nowScrollTop) >= delta) {
                if (nowScrollTop > lastScrollTop) {
                    // SCROLLING DOWN
                    if (scroll >= 600) {
                        $('.site-header, .plugin-banner').removeClass('nav-down').addClass('nav-up');
                    }
                } else {
                    // SCROLLING UP
                    $('.site-header, .plugin-banner').removeClass('nav-up').addClass('nav-down');
                }
                lastScrollTop = nowScrollTop;
            }
        });
    });
});
